const UrlService =  {
    
    API_BASE_PATH : process.env.NODE_ENV !== 'production' ? "https://uauth.unifiedorbit.com" : "https://uauth.unifiedorbit.com",
    BASE_PATH : process.env.NODE_ENV !== 'production' ? "https://uauth.unifiedorbit.com" : "https://uauth.unifiedorbit.com",
    UAUTH_BASE_PATH : process.env.NODE_ENV !== 'production' ? "https://uauth.tradexsafely.com" : "uauth.https://uauth.unifiedorbit.com",
    LOCALHOST_BASE_PATH : process.env.NODE_ENV !== 'production' ? "http://localhost:3000" : "http://209.188.7.238:4144",

    ECOMMERCE_BASE_URL : `https://uauth.unifiedorbit.com/api/v1/ecommerce`,
    PAYMENT_API_BASE_PATH : process.env.NODE_ENV !== 'production' ? "https://uauth.unifiedorbit.com/api/v1/xchange" : "https://uauth.unifiedorbit.com/api/v1/xchange",
    MAIN_PAYMENT_API_BASE_PATH : process.env.NODE_ENV !== 'production' ? "https://uauth.unifiedorbit.com/api/v1/payment" : "https://uauth.unifiedorbit.com/api/v1/payment",
    IMAGE_BASE : process.env.NODE_ENV !== 'production' ? "https://uauth.unifiedorbit.com/xchange/attachments/" : "https://uauth.unifiedorbit.com/xchange/attachments/",
    MULTISERVICE_BASE_API : process.env.NODE_ENV !== 'production' ? "https://uauth.unifiedorbit.com/api/v1" : "https://uauth.unifiedorbit.com/api/v1",
 
    // user management
    GET_TOKEN: "/oauth/token",
    INITIATE_TRANSFER: "/initiate/transfer",
    APPROVE_TRANSFER: "/approve/transfer/",
    CHECK_BALANCE: "/check/account/balance",
    FUND_WALLET: "/fund/wallet/",
    BANK_LIST: "/banks",
    ENQUIRY: "/enquiry/",
    WITHDRAW_FUNDS: "/withdraw/fund",
    AIRTIME_PROVIDERS: "/airtime/providers",
    PURCHASE_AIRTIME: "/airtime/purchase",

    TEMPLATE: "/template",
    TEMPLATES: "/templates",
    SEND_EMAIL: "/send/email",

    


};

export default UrlService